import { TonerJsEnv } from "./toner_js_env";

export class Toner {
  constructor(private model: TonerJsEnv) {
    this.model = { ...model };
  }

  getModel(): TonerJsEnv {
    return {
      ...this.model
    };
  }

  updatePrinterTypes(model: TonerJsEnv, selectedPrinterMaker: string) {
    this.model.selectedPrinterMaker = selectedPrinterMaker;

    this.model.printerTypes = model.printerTypes;
    this.model.selectedPrinterType = null;

    this.model.printerModels = [];
    // nullを設定するとクエリパラメータにnullと表示されるため、string型は空文字を設定する
    this.model.selectedPrinterModel = "";
  }

  updatePrinterModels(model: TonerJsEnv, selectedPrinterType: number | null) {
    this.model.selectedPrinterType = selectedPrinterType;

    this.model.printerModels = model.printerModels;
    this.model.selectedPrinterModel = "";
  }

  updatePrinterModel(selectedPrinterModel: string) {
    this.model.selectedPrinterModel = selectedPrinterModel;
  }

  updateModel(printerTypePullDownModel: TonerJsEnv, printerModelPullDownModel: TonerJsEnv, selectedPrinterMaker: string, selectedPrinterType: number | null, selectedPrinterModel: string) {
    this.model.printerTypes = printerTypePullDownModel.printerTypes;
    this.model.printerModels = printerModelPullDownModel.printerModels;
    this.model.selectedPrinterMaker = selectedPrinterMaker;
    this.model.selectedPrinterType = selectedPrinterType;
    if (selectedPrinterModel === null) {
      this.model.selectedPrinterModel = "";
    } else {
      this.model.selectedPrinterModel = selectedPrinterModel;
    }
  }

  clearPrinterTypes(selectedPrinterMaker: string) {
    this.model.selectedPrinterMaker = selectedPrinterMaker;

    this.model.printerTypes = [];
    this.model.selectedPrinterType = null;

    this.model.printerModels = [];
    this.model.selectedPrinterModel = "";
  }

  clearPrinterModels(selectedPrinterType: number | null) {
    this.model.selectedPrinterType = selectedPrinterType;

    this.model.printerModels = [];
    this.model.selectedPrinterModel = "";
  }
}
